var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSidebarStamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_845_16932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4375 19.8042H18.5625",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8242 12.2417L8.29623 5.10889C8.23223 4.8084 8.23616 4.49742 8.30774 4.19865C8.37932 3.89988 8.51675 3.62087 8.70997 3.38202C8.9032 3.14316 9.14734 2.95049 9.42457 2.81808C9.7018 2.68567 10.0051 2.61687 10.3123 2.6167H11.6873C11.9946 2.61674 12.298 2.68545 12.5754 2.81781C12.8527 2.95016 13.0969 3.14281 13.2903 3.38168C13.4836 3.62055 13.6211 3.89961 13.6927 4.19844C13.7644 4.49727 13.7683 4.80833 13.7043 5.10889L12.1763 12.2417",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.875 12.2417H4.125C3.7453 12.2417 3.4375 12.5495 3.4375 12.9292V16.3667C3.4375 16.7464 3.7453 17.0542 4.125 17.0542H17.875C18.2547 17.0542 18.5625 16.7464 18.5625 16.3667V12.9292C18.5625 12.5495 18.2547 12.2417 17.875 12.2417Z",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_845_16932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.554199)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSidebarStamp);
export default __webpack_public_path__ + "static/media/icon-sidebar-stamp.e57243e6a675189fd55c6f7370312f56.svg";
export { ForwardRef as ReactComponent };